// ...
import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { SwUpdate } from '@angular/service-worker';
import { ToastrService } from 'ngx-toastr';
import { interval, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { PromptComponent } from '../../modules/shared/components/prompt-component/prompt-component.component';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  public promptEvent: any;
  public installableIos: boolean;
  public messageService: ToastrService
  constructor(
    private bottomSheet: MatBottomSheet,
    private platform: Platform,
    public updates: SwUpdate
  ) {
    //console.log('Updated Enabled:' + updates.isEnabled)
    //var self = this;

    //if (updates.isEnabled) {
    //  //self.messageService.info("Updates enabled")
    //  interval(6 * 60 * 60 * 30).subscribe(() => updates.checkForUpdate()
    //    .then(() => {
    //      //console.log('checking for updates')

    //      //self.messageService.info("Updating to new version")
    //    }));
    //}
  }

  //public checkForUpdates(): void {
  //  this.updates.available.subscribe(event => {
  //    console.log('current version is', event.current);
  //    console.log('available version is', event.available);
  //    this.promptUser()
  //  });
  //}

  //private promptUser(): void {
  //  console.log('updating to new version');
  //  //this.messageService.info("Updating to new version")
  //  this.updates.activateUpdate().then(() => document.location.reload());
  //}

  public get isPWADisplayMode() {
    if (this.promptEvent != null || this.installableIos)
      return false;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (document.referrer.startsWith('android-app://')) {
      return true;
    } else if (('standalone' in window.navigator) && (window.navigator['standalone']) || isStandalone) {
      return true;
    }
    return false;
  }

  public initPwaPrompt() {
    if (!this.platform.IOS) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        this.promptEvent = event;
        event.preventDefault();
        //this.openPromptComponent('android');
      });

      
    } else { // if (this.platform.IOS)
      const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
      if (!isInStandaloneMode) {
        this.installableIos = true;
        //this.openPromptComponent('ios');
      }
    }
    window.addEventListener('appinstalled', () => {
      // Optionally, send analytics event to indicate successful install
      if (this.messageService)
     this.messageService.success("Open the application from the installed icon", "App Installed")

    });
  }

  public showPwaPrompt() {
    if (!this.platform.IOS) {
      //window.addEventListener('beforeinstallprompt', (event: any) => {
        //event.preventDefault();
       // this.promptEvent = event;
        this.promptEvent.prompt();
        //this.openPromptComponent('android');
     // });
    }
   else {
      const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
      if (!isInStandaloneMode) {
        this.openPromptComponent('ios');
      }
    }
  }

  private openPromptComponent(mobileType: 'ios' | 'android') {
    timer(50)
      .pipe(take(1))
      .subscribe(() => this.bottomSheet.open(PromptComponent, { data: { mobileType, promptEvent: this.promptEvent } }));
  }
}
